"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Aug 24 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ResearchTypeEnum_1 = require("../../data-pairing/model/ResearchTypeEnum");

var ProductEANConverter_1 = require("../../product/conversions/ProductEANConverter");

var Site_1 = require("../../site/model/Site");

var CompetitorPriceRawData_1 = require("../model/CompetitorPriceRawData");

var CompetitorPriceRawDataConverter_1 = require("./CompetitorPriceRawDataConverter");
/**
 * Default implementation of CompetitorPriceRawDataConverter.
 *
 * @author Jaroslav Sevcik
 */


var CompetitorPriceRawDataConverterImpl =
/*#__PURE__*/
function (_CompetitorPriceRawDa) {
  _inherits(CompetitorPriceRawDataConverterImpl, _CompetitorPriceRawDa);

  function CompetitorPriceRawDataConverterImpl() {
    _classCallCheck(this, CompetitorPriceRawDataConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompetitorPriceRawDataConverterImpl).apply(this, arguments));
  }

  _createClass(CompetitorPriceRawDataConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      var _this = this;

      return new CompetitorPriceRawData_1.CompetitorPriceRawData(conversions.documentToClassId(source), CompetitorPriceRawData_1.CompetitorPriceRawData.agencySchema.uploadId.valueOf(conversions.toClassReferenceId(source.uploadId)), conversions.asEnum(source.siteType, Site_1.SiteType), source.externalCompetitorId, source.competitorName, source.externalSiteId, source.address, source.city, source.externalProductId, source.goldId, source.productName, source.productSize, source.productSizeUnit, source.regularPrice, source.actualPrice, source.promo, source.sellout, source.category, conversions.asObjectOpt(source, 'ean', function (document) {
        return _this.productEANConverter.toObject(document, conversions);
      }), source.eanDescription, conversions.toDate(source.date), source.researchType && conversions.asEnum(source.researchType, ResearchTypeEnum_1.ResearchTypeEnum), source.available, source.productContent, source.productSpecification, source.supplier, source.comment, source.isFromWebScraping);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this2 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var document = {};
      Object.assign(document, conversions.classToDocumentId(source));
      Object.assign(document, {
        uploadId: conversions.toDocumentReferenceId(source.uploadId),
        siteType: source.siteType,
        externalCompetitorId: source.externalCompetitorId,
        competitorName: source.competitorName,
        externalSiteId: source.externalSiteId,
        address: source.address,
        city: source.city,
        externalProductId: source.externalProductId,
        goldId: source.goldId,
        productName: source.productName,
        productSize: source.productSize,
        productSizeUnit: source.productSizeUnit,
        regularPrice: source.regularPrice,
        actualPrice: source.actualPrice,
        promo: source.promo,
        sellout: source.sellout,
        category: source.category,
        ean: conversions.asObjectOpt(source, 'ean', function (productEAN) {
          return _this2.productEANConverter.toDocument(productEAN, conversions);
        }),
        eanDescription: source.eanDescription,
        date: conversions.fromDate(source.date),
        researchType: source.researchType,
        available: source.available,
        productContent: source.productContent,
        productSpecification: source.productSpecification,
        supplier: source.supplier,
        comment: source.comment,
        isFromWebScraping: source.isFromWebScraping
      });
      return document;
    }
  }]);

  return CompetitorPriceRawDataConverterImpl;
}(CompetitorPriceRawDataConverter_1.CompetitorPriceRawDataConverter);

__decorate([typescript_ioc_1.Inject, __metadata("design:type", ProductEANConverter_1.ProductEANConverter)], CompetitorPriceRawDataConverterImpl.prototype, "productEANConverter", void 0);

exports.CompetitorPriceRawDataConverterImpl = CompetitorPriceRawDataConverterImpl;